import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = {
  isUserMenuOpened: false,
  alertBar: {
    opened: false,
    message: '',
    actionLabel: '',
    action: null,
  },
};

const appModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default appModule;
